import { createContext, useContext } from "react";

export const OnboardingContext = createContext<{
  forceOnboarding: boolean;
  setForceOnboarding: (v: boolean) => void;
}>({ forceOnboarding: false, setForceOnboarding: () => {} });

export function useOnboarding() {
  return useContext(OnboardingContext);
}
